const PropTypes = require('prop-types');
const React = require('react');
const moment = require('moment');
const TITLE_LENGTH = 80;

const { Stars } = require('@reverbdotcom/discovery-ui');
const ReviewForm = require('./form.jsx');

class Review extends React.Component {
  constructor() {
    super();

    this.state = {
      formError: null,
      showUpdateForm: false,
    };

    this.handleFormClose = this.handleFormClose.bind(this);
    this.handleFormOpen = this.handleFormOpen.bind(this);
    this.updateSuccess = this.updateSuccess.bind(this);
    this.updateFail = this.updateFail.bind(this);
  }

  updateSuccess() {
    this.setState({ showUpdateForm: false });
    this.props.updateSuccess();
  }

  updateFail(response) {
    const error = JSON.parse(response.responseText);
    this.setState({ formError: error.message });
  }

  handleFormOpen() {
    this.setState({ showUpdateForm: true });
  }

  handleFormClose() {
    this.setState({ showUpdateForm: false });
  }

  updateButton() {
    if (!this.props.review.is_my_review) { return false; }

    return (
      <a
        onClick={this.handleFormOpen}
        className="product-review-edit-btn"
      >
        {I18n.t('js.productReviews.edit')}
      </a>
    );
  }

  renderTitle() {
    if (this.props.review.title) {
      return this.props.review.title;
    }

    return this.props.review.body.substring(0, TITLE_LENGTH);
  }

  renderVerified() {
    if (!this.props.review.verified) { return false; }

    return I18n.t('js.productReviews.verified');
  }

  renderReviewForm() {
    return (
      <li>
        <ReviewForm
          isOpen
          onClose={this.handleFormClose}
          submitSuccess={this.updateSuccess}
          submitFail={this.updateFail}
          saveLink={this.props.review._links.self.href}
          errorMessage={this.state.formError}
          saveMethod="PUT"
          rating={this.props.review.rating}
          body={this.props.review.body}
          title={this.props.review.title}
          submitText={I18n.t('js.productReviews.reviewUpdate')}
        />
      </li>
    );
  }

  renderUserAvatar() {
    return (
      <div className="avatar avatar-large" title={this.props.review.reviewer.shortname}>
        <img
          alt="Reviewer Avatar"
          src={this.props.review.reviewer._links.avatar.href}
        />
      </div>
    );
  }

  renderUserName() {
    return (
      <p className="small strong mb-0" itemProp="author">
        {this.props.review.reviewer.shortname}
      </p>
    );
  }

  renderUser() {
    if (this.props.review.reviewer._links.self) {
      return (
        <a
          href={this.props.review.reviewer._links.self.href}
          className="g-col-2 align-center show-only-on-desktop"
        >
          {this.renderUserAvatar()}
          {this.renderUserName()}
        </a>
      );
    }

    return (
      <div className="g-col-2 align-center show-only-on-desktop">
        {this.renderUserAvatar()}
        {this.renderUserName()}
      </div>
    );
  }

  renderReviewContent() {
    return (
      <li itemProp="review" itemScope itemType="http://schema.org/Review">
        <meta
          content={moment(this.props.review.created_at).format('YYYY-MM-DD')}
          itemProp="datePublished"
        />
        <div className="g-container">
          {this.renderUser()}
          <div className="g-col-10 g-col-mobile-12">
            <div className="g-container">
              <div className="g-col-9" itemProp="reviewRating" itemScope itemType="http://schema.org/Rating">
                <meta content={this.props.review.rating} itemProp="ratingValue" />
                <meta content="5" itemProp="bestRating" />
                <meta content="1" itemProp="worstRating" />
                <h4 className="product-review-title" itemProp="name">
                  {this.renderTitle()}
                </h4>
                <span className="product-review-star-group">
                  <Stars rating={this.props.review.rating} />
                </span>
                <p className="d-inline-block size-90 strong color-orange mb-0 ml-space">{this.renderVerified()}</p>
              </div>
              <div className="g-col-3 align-right">
                <p className="fine-print muted mb-0">
                  {moment(this.props.review.created_at).format('ll')}
                </p>
                {this.updateButton()}
              </div>
            </div>
            <p className="product-review-description" itemProp="reviewBody">
              {this.props.review.body}
            </p>
            <p className="small muted strong show-only-on-mobile mt-half mb-0" itemProp="author">
              {this.props.review.reviewer.shortname}
            </p>
          </div>
        </div>
      </li>
    );
  }

  render() {
    if (this.state.showUpdateForm) {
      return this.renderReviewForm();
    }
    return this.renderReviewContent();
  }
}

Review.propTypes = {
  review: PropTypes.object.isRequired,
  updateSuccess: PropTypes.func.isRequired,
};

module.exports = Review;



// WEBPACK FOOTER //
// ./javascripts/components/product_reviews/review.jsx